export const workflowConstants = {
  GET_ALL_WORKFLOW_REQUEST: "GET_ALL_WORKFLOW_REQUEST",
  GET_ALL_WORKFLOW_SUCCESS: "GET_ALL_WORKFLOW_SUCCESS",
  GET_ALL_WORKFLOW_FAILURE: "GET_ALL_WORKFLOW_FAILURE",

  GET_WORKFLOW_BY_ID_REQUEST: "GET_WORKFLOW_BY_ID_REQUEST",
  GET_WORKFLOW_BY_ID_SUCCESS: "GET_WORKFLOW_BY_ID_SUCCESS",
  GET_WORKFLOW_BY_ID_FAILURE: "GET_WORKFLOW_BY_ID_FAILURE",

  GET_WORKFLOW_TOP_CARD_REQUEST: "GET_WORKFLOW_TOP_CARD_REQUEST",
  GET_WORKFLOW_TOP_CARD_SUCCESS: "GET_WORKFLOW_TOP_CARD_SUCCESS",
  GET_WORKFLOW_TOP_CARD_FAILURE: "GET_WORKFLOW_TOP_CARD_FAILURE",

  ADD_WORKFLOW_REQUEST: "ADD_WORKFLOW_REQUEST",
  ADD_WORKFLOW_SUCCESS: "ADD_WORKFLOW_SUCCESS",
  ADD_WORKFLOW_FAILURE: "ADD_WORKFLOW_FAILURE",

  EDIT_WORKFLOW_BY_ID_REQUEST: "EDIT_WORKFLOW_BY_ID_REQUEST",
  EDIT_WORKFLOW_BY_ID_SUCCESS: "EDIT_WORKFLOW_BY_ID_SUCCESS",
  EDIT_WORKFLOW_BY_ID_FAILURE: "EDIT_WORKFLOW_BY_ID_FAILURE",

  ADD_CONFIGURED_WORKFLOW_BY_ID_REQUEST:
    "ADD_CONFIGURED_WORKFLOW_BY_ID_REQUEST",
  ADD_CONFIGURED_WORKFLOW_BY_ID_SUCCESS:
    "ADD_CONFIGURED_WORKFLOW_BY_ID_SUCCESS ",
  ADD_CONFIGURED_WORKFLOW_BY_ID_FAILURE:
    "ADD_CONFIGURED_WORKFLOW_BY_ID_FAILURE",

  RUN_WORKFLOW_BY_JOB_ID_REQUEST: "RUN_WORKFLOW_BY_JOB_ID_REQUEST",
  RUN_WORKFLOW_BY_JOB_ID_SUCCESS: "RUN_WORKFLOW_BY_JOB_ID_SUCCESS",
  RUN_WORKFLOW_BY_JOB_ID_FAILURE: "RUN_WORKFLOW_BY_JOB_ID_FAILURE",

  GET_DATABRICKS_JOB_STATUS_REQUEST: "GET_DATABRICKS_JOB_STATUS_REQUEST",
  GET_DATABRICKS_JOB_STATUS_SUCCESS: "GET_DATABRICKS_JOB_STATUS_SUCCESS",
  GET_DATABRICKS_JOB_STATUS_FAILURE: "GET_DATABRICKS_JOB_STATUS_FAILURE",

  GET_WORKFLOW_FILTERS_REQUEST: "GET_WORKFLOW_FILTERS_REQUEST",
  GET_WORKFLOW_FILTERS_SUCCESS: "GET_WORKFLOW_FILTERS_SUCCESS",
  GET_WORKFLOW_FILTERS_FAILURE: "GET_WORKFLOW_FILTERS_FAILURE",

  GET_GIT_REPO_BY_CONNECTION_ID_REQUEST: "GET_GIT_REPO_BY_CONNECTION_ID_REQUEST",
  GET_GIT_REPO_BY_CONNECTION_ID_SUCCESS: "GET_GIT_REPO_BY_CONNECTION_ID_SUCCESS",
  GET_GIT_REPO_BY_CONNECTION_ID_FAILURE: "GET_GIT_REPO_BY_CONNECTION_ID_FAILURE",

  ACTIVATE_WORKFLOW_REQUEST: "ACTIVATE_WORKFLOW_REQUEST",
  ACTIVATE_WORKFLOW_SUCCESS: "ACTIVATE_WORKFLOW_SUCCESS",
  ACTIVATE_WORKFLOW_FAILURE: "ACTIVATE_WORKFLOW_FAILURE",

  GET_ACTIVE_WORKFLOW_BY_CONNECTION_ID_REQUEST: "GET_ACTIVE_WORKFLOW_BY_CONNECTION_ID_REQUEST",
  GET_ACTIVE_WORKFLOW_BY_CONNECTION_ID_SUCCESS: "GET_ACTIVE_WORKFLOW_BY_CONNECTION_ID_SUCCESS",
  GET_ACTIVE_WORKFLOW_BY_CONNECTION_ID_FAILURE: "GET_ACTIVE_WORKFLOW_BY_CONNECTION_ID_FAILURE",
};
